import { Instance, SnapshotIn, types } from 'mobx-state-tree';

interface EffectivenessProps {
  percentageValue: number;
}

export const Effectiveness = types.model({
  percentageValue: types.number,
});

interface SingleMarkerProps {
  name: string;
  value: number;
}

export const SingleMarker = types.model({
  name: types.string,
  value: types.number,
});

export interface ChartTabProps {
  percentageValue: number;
  effectiveness: EffectivenessProps;
  markers: SingleMarkerProps[];
}

export const ChartTab = types.model({
  percentageValue: types.number,
  effectiveness: Effectiveness,
  markers: types.optional(types.array(SingleMarker), []),
});

export type ChartTabSnapshot = SnapshotIn<typeof ChartTab>;
export type ChartTabInstance = Instance<typeof ChartTab>;
